import { RETRY_ACTION, TOKEN_REFRESH } from "./actionTypes";

// Action creator for retrying an action
export const retryAction = (actionTypeRetry, payload) => ({
  type: RETRY_ACTION,
  actionTypeRetry,
  payload,
});

export const tokenRefresh = (actionTypeRetry, payload) => ({
  type: TOKEN_REFRESH,
  actionTypeRetry,
  payload,
});
